export const ReservationIntegrationsData = [
  {
    label: 'Pull all reservations data for pre check-in outbound campaigns',
    value: 'reservation_pre_check_in',
  },
  {
    label:
      'Query reservation record to answer guest questions about upcoming reservation',
    value: 'reservation_query',
  },
  {
    label: 'Send invoice copy to customer when requested',
    value: 'reservation_send_invoice',
  },
];
export const PreCheckinRequestData = [
  {
    label: 'Add note to existing reservation',
    value: 'pre_check_in_note',
  },
  {
    label: 'Add alert to existing reservation',
    value: 'pre_check_in_alert',
  },
  {
    label: 'Add trace to existing reservation',
    value: 'pre_check_in_trace',
  },
  {
    label: 'Add Housekeeping Note to Existing Reservation',
    value: 'house_keeping_note',
  },
];
export const HouseKeepingData = [
  {
    label: 'Add note to existing reservation',
    value: 'house_keeping_note',
  },
  {
    label: 'Add alert to existing reservation',
    value: 'house_keeping_alert',
  },
  {
    label: 'Add trace to existing reservation',
    value: 'house_keeping_trace',
  },
];

export const RegformData = [
  {
    label: 'Add Reservation Note',
    value: 'reg_form_reservation_note',
  },
  {
    label:
      'Add Profile Note (Use when you want to add form attachements to profile only) ',
    value: 'reg_form_profile_notes',
  },
  {
    label: 'Add Guest Message',
    value: 'reg_form_guest_message',
  },
  {
    label: 'Add Profile Email',
    value: 'reg_form_add_profile_email',
  },
  {
    label: 'Add Profile Phone Number',
    value: 'reg_form_guest_profile_phone',
  },
  {
    label: 'Update Country in Address',
    value: 'reg_form_guest_country_update',
  },
];
